// @mui
import { Iconic } from '@/commons/iconic';
import { Button, Stack, TextField } from '@mui/material';
import { translates } from '@/utils';
import { PropsProductTableToolbar } from './types';

export default function TableToolbar({ filterName, onFilterName, toolbar }: PropsProductTableToolbar) {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{ px: 2.5, py: 3 }}
    >

        {toolbar}

      <TextField
        fullWidth
        value={filterName}
        onChange={onFilterName}
        placeholder={`${translates.search}...`}
      />
      <Button color="primary" sx={{ flexShrink: 0 }} startIcon={<Iconic icon="eva:search-fill" />}>
        {translates.search}
      </Button>
    </Stack>
  );
}
